import { render, staticRenderFns } from "./SelectImgs.vue?vue&type=template&id=3b1c5cb1&scoped=true"
import script from "./SelectImgs.vue?vue&type=script&lang=js"
export * from "./SelectImgs.vue?vue&type=script&lang=js"
import style0 from "./SelectImgs.vue?vue&type=style&index=0&id=3b1c5cb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c5cb1",
  null
  
)

export default component.exports